import { Channels } from "src/app/shared/store-mocks/channels.store";
import { MessageLogsResponseType } from "../log-analyser.models";

export const mapQueryParamsToResponseType = (qp: any): MessageLogsResponseType  => {
    if(qp.channels === Channels.WHATSAPP){
        return MessageLogsResponseType.Whatsapp
    }

    return MessageLogsResponseType.Sms
} 